import { Login } from 'src/components/login';

export const LoginPage = () => <Login />;
